import React from "react";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  tableContainerStyles,
  tableStyles,
  tableCellStyles,
  tableRowStyles,
} from "../../../HighPerformancePacker/CategoryDetail/style";

const Tabel = () => {
  return (
    <TableContainer sx={tableContainerStyles}>
      <Table sx={tableStyles} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Series&nbsp;(in)</span>
              </Typography>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Thread</span>
              
              </Typography>
            </TableCell>

           
            <TableCell colSpan={2} sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Length (m)</span>
              
              </Typography>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Screen Max OD（mm）</span>
                
              </Typography>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Filtration Jacket</span>
                {/* <span>140-90</span> */}
              </Typography>
            </TableCell>
            <TableCell colSpan={4} sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Base Pipe</span>
              
              </Typography>
            </TableCell>
            {/* <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>152-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>164-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>214-152</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>152-101</span>
              </Typography>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>HR</span>
                <span>213-152</span>
              </Typography>
            </TableCell> */}
          </TableRow>
          <TableRow>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Filter</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Screen</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Type</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Material</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Density of hole（quantity  of hole/m）</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>ID (mm)</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>OD (mm)</span>
              </Typography>
            </TableCell>
            <TableCell  sx={tableCellStyles}>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontWeight: "bold",
                }}
              >
                <span>Flow Area(%)</span>
              </Typography>
            </TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>2 3/8</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>NU</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>5</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>9~11</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>78.5</span>
            </TableCell>
            <TableCell  sx={tableRowStyles}>
              <span>circular hole</span>
            </TableCell>
            <TableCell rowSpan={11} sx={tableRowStyles}>
              <span>316L</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>80</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>50.8</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>60.3</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>3.44</span>
            </TableCell>
            {/* <TableCell sx={tableRowStyles}>
              <span>9&nbsp;5/8</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>7</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>9&nbsp;5/8</span>
            </TableCell> */}
          </TableRow>
          <TableRow>
          <TableCell sx={tableRowStyles}>
              <span>82</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>Strip-type hole</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>2 7/8</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>NU</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>5</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>9~11</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>91</span>
            </TableCell>
            <TableCell  sx={tableRowStyles}>
              <span>circular hole</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>80</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>62</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>73</span>
            </TableCell>
            <TableCell rowSpan={2} sx={tableRowStyles}>
              <span>3.44</span>
            </TableCell>
           
          </TableRow>
          <TableRow>
          <TableCell sx={tableRowStyles}>
              <span>96</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>Strip-type hole</span>
            </TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Weight&nbsp;(ppf)</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>9.5-11.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>13-15</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>15.5-20</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>24-28</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>26-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>23-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>29.7-33.7</TableCell>
            <TableCell sx={tableRowStyles}>
              <span>40-47</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>26-29</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>40-47</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tableRowStyles} rowSpan={2}>
              <span>Max&nbsp;OD</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>(mm)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>94</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>104</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>115</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>140</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>151</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>164</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>214</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>213</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={tableRowStyles}>
              <span>(in)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>3.7</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4.09</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4.53</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.51</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.9</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>6.45</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>8.43</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>8.39</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tableRowStyles} rowSpan={2}>
              <span>Min&nbsp;ID</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>(mm)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>54</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>68</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>62</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>90</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>101.6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>152</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={tableRowStyles}>
              <span>(in)</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2.13</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2.68</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2.44</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>3.54</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5.98</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Setting Pressure&nbsp;(psi)</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>1700-2600</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Pressure Grade&nbsp;(psi)</span>
            </TableCell>
            <TableCell colSpan={4} sx={tableRowStyles}>
              <span>7000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5000</span>
            </TableCell>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>10000</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Temperature Rating&nbsp;(℃)</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>120/150/180</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Top Thread</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2 7/8NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>3</span>
              <br />
              <span>1/2 NU</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2</span>
              <br />
              <span>7/8 NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM95×6</span>
            </TableCell>
            <TableCell colSpan={3} sx={tableRowStyles}>
              <span>RM106×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM158×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM115×6</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>RM168×6</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Top Thread</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>2 7/8NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>3</span>
              <br />
              <span>1/2 NU</span>
            </TableCell>

            <TableCell sx={tableRowStyles}>
              <span>2</span>
              <br />
              <span>7/8 NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4〞NU</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
              <br />
              <span>1/2″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>5″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>4</span>
              <br />
              <span>1/2″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>7″ LTC</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>M128×2.5</span>
            </TableCell>
            <TableCell sx={tableRowStyles}>
              <span>M182×3</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Setting</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>Hydraulic</span>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} sx={tableRowStyles}>
              <span>Release</span>
            </TableCell>
            <TableCell colSpan={10} sx={tableRowStyles}>
              <span>Retrieving Tool</span>
            </TableCell>
          </TableRow> */}

        
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tabel;
